import React from 'react';

const Loading = () => <div style={{width: '100%', height: '90vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#000'}}><div class="lds-ripple"><div></div><div></div></div></div> ;

export default Loading
